
@if (routerUrl$ | async; as routerUrl){
    <div class="hidden  menu w-full lg:flex justify-start items-center gap-8 font-bold text-lrpTicketBlack">
        <button class="menu-item" [routerLink]="['/admin/events/',lrpEvent?.eventLink]" [class.active]="routerUrl === '/admin/events/' + lrpEvent?.eventLink">
            View Bookings
        </button>
        <div class="dropdown">
            <button class="dropbtn">Event Admin</button>
            <div class="dropdown-content">
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'details']">Event Details</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'tickets']">Event Tickets</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'catering']">Catering</a>
                <a>Event Pack</a>
                <a (click)="showWizard.emit()">Wizard</a>

            </div>
        </div>
        <div class="dropdown">
            <button class="dropbtn">Event Reports</button>
            <div class="dropdown-content">
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'reports/signin']">Sign-in Sheet</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'reports/attendees']">Attendees</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'reports/catering']">Catering</a>
                <a>Dietary</a>
                <a>Medical</a>
            </div>
        </div>
        <div class="dropdown">
            <button class="dropbtn">Downloads</button>
            <div class="dropdown-content">
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'reports/eventpack']">Event Pack</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'csv/attendees']">Attendees CSV</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'csv/catering']">Catering CSV</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'csv/dietary']">Dietary CSV</a>
                <a [routerLink]="['/admin/events/',lrpEvent?.eventLink,'csv/medical']">Medical CSV</a>
            </div>
        </div>
        <div class="dropdown">
            <button class="dropbtn">E-mail</button>
            <div class="dropdown-content">
                <a routerLink="/admin">Event Details</a>
                <a routerLink="/account">Event Tickets</a>
                <a routerLink="/account">Catering</a>
                <a>Event Pack</a>
            </div>
        </div>
    </div> 
}